import React from 'react';
import { Outlet } from 'react-router-dom';
import { PaelbiHeader } from '../components/layout/PaelbiHeader';
import { PaelbiFooter } from '../components/layout/PaelbiFooter';
import { useLanguage } from '../context/LanguageContext';

export function PaelbiLayout() {
  const { lang } = useLanguage();
  return (
    <div className="flex min-h-screen flex-col bg-paelbi-bg">
      <PaelbiHeader />
      <main key={lang} className="flex-1">
        <Outlet />
      </main>
      <PaelbiFooter />
    </div>
  );
}

export default PaelbiLayout;
